import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Cache } from 'aws-amplify';
import { Row, Col, Button, Form } from 'react-bootstrap';

import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";

import { handleFieldChange, upsertHoliday, getHoliday, resetHoliday } from '../../../store/actions/holidays/holidaysActions';
import { PORTAL_ADMIN, PROJECT_ADMIN } from '../../../store/actions/users/usersActions';

import PageTitle from '../../../common/PageTitle';

import '../../../css/holidays.css';

class HolidayForm extends Component {

  constructor(props) {
    super(props);

    this.submitButtonText = 'Submit';
    this.pageTitle = '';
    this.action = '';
  }
  componentDidMount() {
    const roleId = Cache.getItem('roleId');
    if (roleId === PORTAL_ADMIN || roleId === PROJECT_ADMIN) {
      const pathname = this.props.location.pathname;
      if (pathname === '/settings/holidays/update') {
        const urlParams = new URLSearchParams(this.props.location.search);
        const holidayId =  urlParams.get('id');
        this.props.getHoliday(holidayId);
      }
    }
    else {
      this.props.history.push('/dashboard');
    }
  }

  componentWillUnmount() {
    this.props.resetHoliday();
  }

  handleSubmit = (e) => {
    e.preventDefault();

    const submitButton = document.querySelector("button[type='submit']");
    submitButton.disabled = true;
    if (this.submitButtonText === 'Submit') {
      submitButton.textContent = "Submitting...";
    }
    else {
      submitButton.textContent = "Updating...";
    } 

    this.props.upsertHoliday(this.action, () => {
      this.props.history.push('/settings/holidays');
    });

    submitButton.disabled = false;
    if (this.submitButtonText === 'Submit') {
      submitButton.textContent = "Submitted!";
    }
    else {
      submitButton.textContent = "Updated!";
    }

    setTimeout(() => {  
      submitButton.textContent = this.submitButtonText;
    }, 1000);
  }

  render() {
    let formTitle = '';
    const pathname = this.props.location.pathname;

    if (pathname === '/settings/holidays/update') {
      this.submitButtonText = 'Update';
      formTitle = 'Update Holiday';
      this.action = 'UPDATE_HOLIDAY';
    }
    else {
      formTitle = 'Create Holiday';
      this.action = 'ADD_HOLIDAY';
    }    

    let holidayName = '';
    let holidayDate = '';

    const holiday = this.props.holidays.holiday;

    if (Object.keys(holiday).length) {
      holidayName = holiday.name;

      if (holiday.date) {
        holidayDate = new Date(holiday.date)
      }
    }

    return (
      <>
        <PageTitle pageName={formTitle} />
        <Form className="mt-3" onSubmit={this.handleSubmit}>
          <Row>
            <Col xs={4} sm={4} md={4} lg={4} xl={4}>
              <Form.Group controlId="name">
                <Form.Label>Holiday Name</Form.Label>
                <Form.Control 
                  type="text" 
                  value={holidayName} 
                  onChange={this.props.handleFieldChange} />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col xs={4} sm={4} md={4} lg={4} xl={4}>
              <Form.Group controlId="client_code">
                <Form.Label>Date</Form.Label>
                <DatePicker 
                  selected={holidayDate} 
                  id="holiday_date" 
                  autoComplete="off" 
                  className="form-control form-control-sm" 
                  onChange={(date) => {
                      this.disableSubmit = false;
                      this.props.handleFieldChange(null, {
                        date
                    })
                }} />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col xs={4} sm={4} md={4} lg={4} xl={4}>  
              <div className="float-right">
                <Button variant="default" onClick={() => {
                    this.props.history.push('/settings/holidays');
                  }}>Cancel</Button> 
                <Button variant="primary" type="submit">{this.submitButtonText}</Button>
              </div>
            </Col>
          </Row>
        </Form>
      </>
    )
  }
}

const mapStateToProps = (state) => ({
  holidays: state.holidays
});

const mapDispatchToProps = (dispatch) => ({
  handleFieldChange: (...args) => dispatch(handleFieldChange(...args)),
  upsertHoliday: (...args) => dispatch(upsertHoliday(...args)), 
  getHoliday: (...args) => dispatch(getHoliday(...args)),
  resetHoliday: () => dispatch(resetHoliday())
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(HolidayForm))
